import { render, staticRenderFns } from "./VaultView.vue?vue&type=template&id=2719f9c0&scoped=true&"
import script from "./VaultView.vue?vue&type=script&lang=js&"
export * from "./VaultView.vue?vue&type=script&lang=js&"
import style0 from "./VaultView.vue?vue&type=style&index=0&id=2719f9c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2719f9c0",
  null
  
)

export default component.exports